import { render, staticRenderFns } from "./SectionWrapper.vue?vue&type=template&id=ed7310d8&scoped=true&"
import script from "./SectionWrapper.vue?vue&type=script&lang=js&"
export * from "./SectionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SectionWrapper.vue?vue&type=style&index=0&id=ed7310d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7310d8",
  null
  
)

export default component.exports